<template>
    <modal :show-title="true" size="small" @close="$emit('close')">
        <div slot="header">
            <h5 class="modal-title">{{$t('prenotazione.annulla')}}</h5>
        </div>
        <div slot="body" class="text-center">
            <div class="bg-gray rounded-lg p-3 f13 text-center">
                <p><i>{{$t('prenotazione.info_annulla')}}</i></p>
                <div class="d-flex align-items-center justify-content-center">
                  <i class="pi pi-phone f22 mr-2"></i>
                  <b>{{this.phone}}</b>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
    import Modal from "../../partials/Modal";

    export default {
        name: "ModalCancelReservation",
        components: {Modal},
        props: ['phone']
    }
</script>
